import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';

export const FaqSection = () => {
  const { t } = useTranslation('landing');
  const faqs = [
    {
      question: t('faq.11.q'),
      answer: t('homepage.faq.errorAnswer')
    },
    {
      question: t('faq.3.q'),
      answer: t('faq.3.a')
    },
    {
      question: t('faq.5.q'),
      answer: t('faq.5.a')
    },
    {
      question: t('faq.6.q'),
      answer: t('faq.6.a')
    },
    {
      question: t('homepage.faq.mfaQuestion'),
      answer: t('homepage.faq.mfaAnswer')
    },
    {
      question: t('faq.7.q'),
      answer: t('faq.7.a')
    }
  ];

  return (
    <section className={styles.faqSection} id='faqs'>
      <div className={styles.faqShell}>
        <div className={styles.faqIntro}>
          <h2>
            {t('homepage.faq.title')}
            <b>.</b>
          </h2>
          <p>{t('homepage.faq.description')}</p>
          <NextLink href='https://docs.eezi.io/docs/overview'>
            {t('homepage.faq.link')} <span>→</span>
          </NextLink>
        </div>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <details key={faq.question} open={index === 0}>
              <summary>
                <span>{faq.question}</span>
                <i />
              </summary>
              <p>{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
